import { componentFactoryOf } from 'vue-tsx-support';

import { JtnUiTypography, JtnUiBtn } from '@jtnews/jtn-ui';
import { injectStylesMixin } from '@jtnews/shared';

import styles from './record-related-news.styles.scss?module';

interface Events {
  onClickedToRecord: {
    id: number;
    type: 'MN' | 'ML';
  };
  onClickedAlsoBtn: void;
  onClickedCounter: void;
}

type RelatedNews = {
  header: string;
  id: number;
  publishAt: string;
  urls: {
    url: string;
    urlCanonical: string;
    urlComments: string;
  };
  type: 'MN' | 'ML';
};

type ComponentData = {
  showOtherNews: boolean;
};

const VISIBLE_NEWS_COUNT = 5;

export default componentFactoryOf<Events>()
  .mixin(injectStylesMixin(styles))
  .create({
    name: 'RecordRelatedNews',
    props: {
      recordList: {
        type: Array as () => RelatedNews[],
        required: true
      },
      isCommercial: {
        type: Boolean,
        default: false
      }
    },
    data(): ComponentData {
      return {
        showOtherNews: false
      };
    },
    computed: {
      newsList(): RelatedNews[] {
        return this.recordList || [];
      },
      totalNewsCount(): number {
        return this.newsList.length;
      },
      headerTitle(): string {
        return this.isCommercial ? 'Читать еще' : 'По теме';
      },
      hasShowAlsoBtn(): boolean {
        return !this.showOtherNews && this.totalNewsCount > VISIBLE_NEWS_COUNT;
      }
    },
    watch: {
      data() {
        this.showOtherNews = false;
      }
    },
    methods: {
      toRecord(news: RelatedNews) {
        this.$emit('clickedToRecord', {
          id: news.id,
          type: news.type
        });
      },
      clickShowAlsoBtn(place: 'counter' | 'button') {
        this.showOtherNews = true;

        place === 'counter' ? this.$emit('clickedCounter') : this.$emit('clickedAlsoBtn');
      }
    },
    render() {
      return (
        <div>
          {this.totalNewsCount > 0 && (
            <div class={styles.recordRelatedNews}>
              <JtnUiTypography tag="p" class={styles.title} type="font-vijet-title">
                {this.headerTitle}
                {this.totalNewsCount > VISIBLE_NEWS_COUNT && (
                  <button
                    class={styles.totalCountIcon}
                    onClick={() => this.clickShowAlsoBtn('counter')}
                  >
                    {this.totalNewsCount}
                  </button>
                )}
              </JtnUiTypography>

              <ul class={styles.newsList}>
                {this.newsList.map((news: RelatedNews, index: number) => (
                  <li
                    key={index}
                    class={[
                      styles.news,
                      !this.showOtherNews && index >= VISIBLE_NEWS_COUNT
                        ? styles.hidden
                        : ''
                    ]}
                  >
                    <JtnUiTypography
                      class={styles.date}
                      tag="p"
                      type="font-toolbar-notice-txt"
                    >
                      {news.publishAt}
                    </JtnUiTypography>

                    <JtnUiTypography
                      tag="a"
                      type="font-second-news-txt"
                      linkType="link-blue"
                      href={news.urls.url}
                      nativeOnClick={() => {
                        this.toRecord(news);
                      }}
                    >
                      <span class={styles.newsLink} domPropsInnerHTML={news.header} />
                    </JtnUiTypography>
                  </li>
                ))}
              </ul>
              {this.hasShowAlsoBtn && (
                <JtnUiBtn
                  class={styles.button}
                  theme={'lightGray'}
                  onClick={() => this.clickShowAlsoBtn('button')}
                >
                  Показать все
                </JtnUiBtn>
              )}
            </div>
          )}
        </div>
      );
    }
  });
